// File: src/pages/ContentViewPage.js
// This new page displays a single piece of content.
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ContentViewPage({ allContent }) {
  const { slug } = useParams();
  const content = allContent.find(item => item.slug === slug);

  if (!content) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center bg-black p-6">
        <h1 className="text-5xl font-bold text-magenta mb-4">404 - Not Found</h1>
        <p className="text-lg text-gray-400">Sorry, the content you are looking for does not exist.</p>
        <Link to="/" className="mt-8 text-lime font-bold hover:underline">Go back to Homepage</Link>
      </div>
    );
  }

  return (
    <>
      <Header />
      <main className="container mx-auto px-6 py-12">
        <article className="max-w-4xl mx-auto">
          <header className="mb-8">
            <p className="text-lime font-bold uppercase">{content.category}</p>
            <h1 className="text-4xl md:text-6xl font-black my-4 text-magenta">{content.title}</h1>
            <p className="text-gray-400">Published on {content.date}</p>
          </header>
          
          {content.type === 'Article' && (
            <div className="prose prose-invert lg:prose-xl max-w-none">
              <img src="https://placehold.co/1200x600/82F52C/000000?text=Header+Image" alt={content.title} className="rounded-lg mb-8" />
              <p>{content.contentBody || 'This is the full body of the article. It will contain detailed information, tips, and advice related to the topic. We are using placeholder text here for now.'}</p>
            </div>
          )}

          {content.type === 'Video' && (
            <div>
              <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden mb-8">
                {/* In a real app, you would use a proper video player (e.g., from a URL) */}
                <iframe 
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/dQw4w9WgXcQ" // Placeholder video
                  title="YouTube video player" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen>
                </iframe>
              </div>
              <p className="text-lg text-gray-300">{content.description}</p>
            </div>
          )}
        </article>
      </main>
      <Footer />
    </>
  );
}

export default ContentViewPage;
